/**
 * Emits the event on every ancestor of the root Vue instance
 * @param {string} name event name
 * @param {any} payload event payload (usually an object)
 * @param {Vue} root vue componant instance (`this` from inside the component)
 */
export function EmitUp(name, payload, root)
{
  root.$emit(name, payload);
  let parent = root.$parent;
  while (parent) {
    parent.$emit(name, payload);
    parent = parent.$parent;
  }
}